<template>
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.47247 9.2C7.39247 9.2 7.32247 9.18 7.25247 9.14L5.00247 7.68001L2.75247 9.14C2.61247 9.23 2.43247 9.22 2.30247 9.13C2.17247 9.03 2.11247 8.86 2.15247 8.7L2.86247 6.2L0.752469 4.42C0.632469 4.32 0.582467 4.15 0.632467 3.99C0.682467 3.84 0.822467 3.73 0.982467 3.71L3.51247 3.53L4.65247 1.04C4.72247 0.900002 4.86247 0.809998 5.01247 0.809998C5.17247 0.809998 5.31247 0.900002 5.37247 1.04L6.51247 3.53L9.04247 3.71C9.20247 3.72 9.34247 3.83 9.39247 3.99C9.44247 4.14 9.39247 4.31 9.27247 4.42L7.16247 6.2L7.87247 8.7C7.92247 8.86 7.86247 9.03 7.72247 9.13C7.64247 9.17 7.56247 9.2 7.47247 9.2Z" :fill="fill"/>
  </svg>

</template>

<script>
  export default {
    name: 'starIcon',
    props: {
      fill: {
        type: String,
        default: '#00527F'
      }
    }
  }
</script>
